// Define the sanitizeTitle function
export function sanitizeTitle(title) {
  if (!title) return ""; // Check if title is undefined or null
  let slug = title
    .toLowerCase()
    .replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e")
    .replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a")
    .replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o")
    .replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u")
    .replace(/đ/gi, "d")
    .replace(/\s*$/g, "")
    .replace(/\s+/g, "-");

  return slug;
}

const slugifyPlugin = {
  install(app) {
    app.config.globalProperties.$sanitizeTitle = sanitizeTitle;
  },
};

export default slugifyPlugin;
